<p>auth-redirect-login works!</p>
